import { lazy } from "react";
import gameOfLifePreview from "./gameOfLife/conway_game_of_life.png";
import terminalPreview from "./terminal/terminalPreview.png";
import diceGamePreview from "./dice/dice-game.png";
import coinFlipPreview from "./coinFlip/coin-circular-preview.png";
import simPlanetsPreview from "./simPlanets/sim-planet-preview.png";

export interface InteractiveDefinition {
  name: string;
  title: string;
  /** Date first added to the site (YYYY-MM-DD), backfilled from Git history. */
  createdAt: string;
  desc?: string;
  originalFramework?: string;
  originalLanguage?: string;
  originalYear?: string;
  image?: any;
  component?: any;
  author?: string;
  remakeFramework?: string;
  remakeLanguage?: string;
  remakeYear?: string;
  fullscreen?: boolean;
}

export const interactiveDefinitions: InteractiveDefinition[] = [
  {
    name: "cgol",
    createdAt: "2024-09-29",
    title: "Conway's Game of Life",
    desc: "Conway's Game of Life cellular automaton simulation built with React and Typescript",
    originalFramework: "React",
    originalLanguage: "Typescript",
    originalYear: "2021",
    component: lazy(() => import("./gameOfLife/GameOfLife")),
    image: gameOfLifePreview,
    author: "Scott Brown"
  },
  {
    name: "terminal",
    createdAt: "2026-03-10",
    title: "Terminal",
    desc: "An interactive terminal emulator built with React and Typescript",
    originalFramework: "React",
    originalLanguage: "Typescript",
    originalYear: "2026",
    component: lazy(() => import("./terminal/Terminal")),
    image: terminalPreview,
    author: "Scott Brown"
  },
  {
    name: "dice",
    createdAt: "2026-03-14",
    title: "Dice",
    desc: "An interactive 3D dice roller built with React and Typescript",
    originalFramework: "React",
    originalLanguage: "Typescript",
    originalYear: "2026",
    component: lazy(() => import("./dice/DiceGame")),
    image: diceGamePreview,
    author: "Scott Brown"
  },
  {
    name: "simPlanets",
    createdAt: "2026-04-04",
    title: "Sim Planets",
    desc: "A 3D solar system simulation with AI spacecraft, originally written in C++ with OpenGL in 2008",
    originalLanguage: "C++",
    originalFramework: "DirectX",
    originalYear: "2007",
    remakeLanguage: "Typescript",
    remakeFramework: "React Three Fiber",
    remakeYear: "2026",
    image: simPlanetsPreview,
    component: lazy(() => import("./simPlanets/SimPlanets")),
    author: "Scott Brown",
    fullscreen: true
  },
  {
    name: "coin-flip",
    createdAt: "2026-09-04",
    title: "Coin Flip",
    desc: "Flip an animated coin using cryptographically secure browser randomness",
    originalFramework: "React",
    originalLanguage: "Typescript",
    originalYear: "2026",
    component: lazy(() => import("./coinFlip/CoinFlip")),
    image: coinFlipPreview,
    author: "Scott Brown"
  }
];
